import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Suppress ResizeObserver dev overlay
const originalError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && message.includes('ResizeObserver')) return true;
  return originalError?.(message, source, lineno, colno, error);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);